import AccountAddresses from './AccountAddresses'

export default AccountAddresses
